// // ============================================================
// //
// // Vanilla Color Picker v 0.1.8
// //
// // http://github.com/miroshko/vanilla-color-picker
// //
// // This project is licensed under the terms of the MIT license.
// //
// // ============================================================
// !function(e){function t(e,t,i){var n=i?"vanilla-color-picker-single-color-picked":""
// return'<div class="vanilla-color-picker-single-color '+n+'" tabindex="'+t+'" data-color="'+e+'" style="background-color:'+e+'"></div>'}function i(){if(!document.getElementById("vanilla-color-picker-style")){var t=document.createElement("style")
// t.setAttribute("type","text/css"),t.setAttribute("id","vanilla-color-picker-style"),t.innerHTML=l
// var i=e.document.head.children[0]
// i?e.document.head.insertBefore(t,i):e.document.head.appendChild(t)}}function n(){this.subscribers={},this.on=function(e,t){return this.subscribers[e]=this.subscribers[e]||[],this.subscribers[e].push(t),this},this.emit=function(e){var t=arguments;(this.subscribers[e]||[]).forEach(function(e){e.apply(null,Array.prototype.splice.call(t,1))})}}function s(e,i,s){n.apply(this),this.targetElem=e,this.elem=null
// var o=this
// this._initialize=function(){this._createPickerElement(),this._positionPickerElement(),this._addEventListeners()},this.destroy=function(){try{this.elem.parentNode.removeChild(this.elem)}catch(e){}},this._positionPickerElement=function(){var e=this.targetElem.offsetLeft,t=this.targetElem.offsetTop,i=this.targetElem.offsetHeight
// this.elem.style.left=e+"px",this.elem.style.top=t+i+"px"},this._onFocusLost=function(){setTimeout(function(){o.elem.contains(document.activeElement)?document.activeElement.addEventListener("blur",o._onFocusLost):o.emit("lostFocus")},1)},this._createPickerElement=function(){this.elem=document.createElement("div"),this.elem.classList.add("vanilla-color-picker"),s&&this.elem.classList.add(s)
// for(var e=i.indexOf(this.targetElem.dataset.vanillaPickerColor),n=0;n<i.length;n++)this.elem.innerHTML+=t(i[n],n+1,n==e)
// this.targetElem.parentNode.appendChild(this.elem),this.elem.setAttribute("tabindex",1)
// var r=e>-1?e:0
// this.elem.children[r].focus(),this.elem.children[r].addEventListener("blur",o._onFocusLost)},this._addEventListeners=function(){var e=this
// this.elem.addEventListener("click",function(t){t.target.classList.contains("vanilla-color-picker-single-color")&&e.emit("colorChosen",t.target.dataset.color)}),this.elem.addEventListener("keydown",function(t){var i=13,n=27,s=t.which||t.keyCode
// s==i&&e.emit("colorChosen",t.target.dataset.color),s==n&&e.emit("lostFocus")})},this._initialize()}function o(e){n.apply(this),this.set=this.emit,this.colors=c,this.className="",this.elem=e,this.currentPicker=null
// var t=this
// this._initialize=function(){this._addEventListeners()},this._addEventListeners=function(){this.elem.addEventListener("click",this.openPicker),this.elem.addEventListener("focus",this.openPicker),this.on("customColors",function(e){if(!(e instanceof Array))throw new Error("Colors must be an array")
// t.colors=e}),this.on("defaultColor",function(e){t.elem.dataset.vanillaPickerColor||(t._updateElemState(e),t.emit("colorChosen",e,t.elem))}),this.on("className",function(e){t.className=e})},this._updateElemState=function(e){this.elem.dataset.vanillaPickerColor=e,this.elem.value=e},this.destroyPicker=function(){t.currentPicker&&(t.currentPicker.destroy(),t.currentPicker=null,t.emit("pickerClosed"))},this.openPicker=function(){t.currentPicker||(t.currentPicker=new s(t.elem,t.colors,t.className),t.currentPicker.on("colorChosen",function(e){t._updateElemState(e),t.destroyPicker(),t.emit("colorChosen",e,t.elem)}),t.currentPicker.on("lostFocus",function(){t.emit("lostFocus"),t.destroyPicker()}),t.emit("pickerCreated"))},this._initialize()}function r(e,t){return i(),new o(e,t)}var l=".vanilla-color-picker { display: inline-block; position: absolute; z-index: 100; padding: 5px; background-color: #fff; box-shadow: 1px 1px 2px 1px rgba(0,0,0,0.3) } .vanilla-color-picker-single-color { display: inline-block; width: 20px; height: 20px; margin: 1px; border-radius: 2px; }",c=["red","yellow","green"]
// e.define&&e.define.amd?define([],function(){return r}):e.vanillaColorPicker=r}(this||window);




// // // Allow style attributes on text elements to not be stripped out by statamic's sanitizer!
// Statamic.bard.sanitizer = {
//     tags: {
//         p: { style: true },
//         br: {},
//         b: { style: true },
//         span: { style: true },
//         strong: { style: true },
//         i: { style: true },
//         strike: {},
//         blockquote: {},
//         code: {},
//         ol: { style: true },
//         ul: { style: true },
//         li: { style: true },
//         a: { href: true, target: true, rel: true },
//         h1: { style: true },
//         h2: { style: true },
//         h3: { style: true },
//         h4: { style: true },
//         h5: { style: true },
//         h6: { style: true },
//         u: { style: true },
//         sup: {},
//         sub: {},
//         hr: {},
//         table: {},
//         thead: {},
//         tbody: {},
//         tr: {},
//         td: {},
//     }
// };


// // // Adaptation of this plugin https://github.com/jsiebern/scribe-plugin-span-style

// const scribeInlineColorStyle = function (styleName = 'color') {

//     return function(scribe) {
//         var spanStyleCommand = new scribe.api.SimpleCommand(styleName);
//         spanStyleCommand.nodeName = 'SPAN';

//         var clearChildStyles = function(root) {
//             if (typeof root === 'undefined' || typeof root.childNodes === 'undefined' || typeof root.nodeType === 'undefined' || root.nodeType === 3) return;

//             for (var i in root.childNodes) {
//                 clearChildStyles(root.childNodes[i]);
//             }

//             root.style[styleName] = '';
//             if (root.nodeName === 'SPAN') {
//                 if (!root.getAttribute('style')) {
//                     scribe.node.unwrap(root.parentNode, root);
//                 }
//             }
//         };

//         var nextNode = function(node) {
//             if (node.hasChildNodes()) {
//                 return node.firstChild;
//             }
//             else {
//                 while (node && !node.nextSibling) {
//                     node = node.parentNode;
//                 }
//                 if (!node) {
//                     return null;
//                 }
//                 return node.nextSibling;
//             }
//         };

//         var getRangeSelectedNodes = function(range) {
//             var node = range.startContainer;
//             var endNode = range.endContainer;

//             if (node === endNode) {
//                 return [node];
//             }

//             var rangeNodes = [];
//             while (node && node !== endNode) {
//                 rangeNodes.push(node = nextNode(node));
//             }

//             node = range.startContainer;
//             while (node && node !== range.commonAncestorContainer) {
//                 rangeNodes.unshift(node);
//                 node = node.parentNode;
//             }

//             return rangeNodes;
//         };

//         var getLogicalCombinations = function(fragments) {
//             var p = [];
//             for (var i=0;i<fragments.length;i++) {
//                 var f = fragments[i];

//                 p.push(f);
//                 for (var x = i+1;x<fragments.length;x++) {
//                     f += fragments[x];
//                     p.push(f);
//                 }
//             }
//             return p;
//         };

//         var styleLogicalFragments = function(root, fragments, value) {
//             if (typeof root === 'undefined' || root.nodeType === 3) return;

//             if (fragments.indexOf(root.textContent) > -1) {
//                 clearChildStyles(root);
//                 root.style[styleName] = value;
//             }
//             else if (root.childNodes) {
//                 for (var i in root.childNodes) {
//                     styleLogicalFragments(root.childNodes[i], fragments, value);
//                 }
//             }
//         };

//         var normalizeNodes = function(root) {
//             if (typeof root === 'undefined' || root.nodeType === 3 || typeof root.nodeType === 'undefined') return;

//             if (root.childNodes) {
//                 for (var i in root.childNodes) {
//                     normalizeNodes(root.childNodes[i]);
//                 }
//             }

//             root.normalize();
//         };

//         var createSubRange = function(node, start, end) {
//             var subRange = document.createRange();
//             subRange.setStart(node, start);
//             subRange.setEnd(node, end);

//             return subRange;
//         };

//         spanStyleCommand.execute = function(value) {
//             console.log('executing command', value);
//             var selection = new scribe.api.Selection();
//             var range = selection.range;

//             if (typeof value.range !== 'undefined') {
//                 // Sometimes a click on the firing element (button etc.) causes the selection to lose focus
//                 // If needed a range from the original selection can be passed alongside the value
//                 range = value.range;
//                 value = value.value;
//             }

//             if (range.collapsed) {
//                 // Trying to style a collapsed range makes no sense
//                 return;
//             }

//             scribe.transactionManager.run(function() {
//                 var nodes = getRangeSelectedNodes(range);

//                 if (nodes.length === 1) {
//                     var node = nodes[0];
//                     var parent = node.parentNode;
//                     if (node.nodeType === 3) {
//                         if (parent.textContent === range.startContainer.textContent.substr(range.startOffset,range.endOffset)) {
//                             clearChildStyles(parent);
//                             parent.style[styleName] = value;
//                         }
//                         else {
//                             var span = document.createElement('span');
//                             span.style[styleName] = value;

//                             range.surroundContents(span);
//                         }
//                     }
//                 }
//                 else {
//                     var startOffset = range.startOffset;
//                     var startContainer = range.startContainer;
//                     var endOffset = range.endOffset;
//                     var endContainer = range.endContainer;

//                     var fragments = [];
//                     for (var i in nodes) {
//                         var node = nodes[i];
//                         if (node.nodeType === 3) {
//                             if (node === range.startContainer) {
//                                 fragments.push(node.textContent.substr(range.startOffset));
//                             }
//                             else if (node === range.endContainer) {
//                                 fragments.push(node.textContent.substr(0,range.endOffset));
//                             }
//                             else {
//                                 fragments.push(node.textContent);
//                             }
//                         }
//                     }
//                     fragments = getLogicalCombinations(fragments);

//                     if (scribe.el.childNodes) {
//                         for (var i in scribe.el.childNodes) {
//                             var rootNode = scribe.el.childNodes[i];
//                             styleLogicalFragments(rootNode, fragments, value);
//                         }
//                     }

//                     if (startOffset > 0) {
//                         var parent = startContainer.parentNode;
//                         if (parent.innerText === startContainer.textContent.substr(startOffset)) {
//                             clearChildStyles(parent);
//                             parent.style[styleName] = value;
//                         }
//                         else {
//                             var subRange = createSubRange(startContainer, startOffset, startContainer.textContent.length);

//                             var span = document.createElement('span');
//                             span.style[styleName] = value;

//                             subRange.surroundContents(span);
//                         }
//                     }

//                     if (endOffset < endContainer.textContent.length) {
//                         var parent = endContainer.parentNode;
//                         if (parent.innerText === endContainer.textContent.substr(0,endOffset)) {
//                             clearChildStyles(parent);
//                             parent.style[styleName] = value;
//                         }
//                         else {
//                             var subRange = createSubRange(endContainer, 0, endOffset);

//                             var span = document.createElement('span');
//                             span.style[styleName] = value;

//                             subRange.surroundContents(span);
//                         }
//                     }

//                 }

//                 if (scribe.el.childNodes) {
//                     normalizeNodes(scribe.el);
//                 }
//             });
//         };

//         spanStyleCommand.queryEnabled = function () {
//             return true;
//         };

//         scribe.commands[styleName] = spanStyleCommand;
//     };
// };

// Statamic.bard.plugins.push(scribeInlineColorStyle);

// (function () {

//     var scribePluginColourPicker = function () {

//         var scribeRef = null;
//         var selection = null;
//         var picker = null;
//         // var pickerVisible = false;

//         var createPicker = function (selection) {

//             var picker = vanillaColorPicker(document.querySelector('.bard-toolbar>button[data-original-title="Color"]'));
//             var pickerColors = [
//                 '#5D5D5D', '#000000', '#8D85C9', '#022169', '#26458B', '#008996', '#FF7F2E', '#B51783'
//             ];

//             picker.set('customColors', pickerColors);

//             picker.on('colorChosen', function (color) {

//                 var selection = new scribeRef.api.Selection();
//                 selection.selectMarkers();
//                 scribeRef.el.focus();

//                 setTimeout(function(){
//                     var colCommand = scribeRef.getCommand('color');
//                     console.log('colCommand', color, selection);
//                     colCommand.execute(color);
//                     // colCommand.execute({
//                     //     value: color,
//                     //     range: selection.range,
//                     // });

//                     selection.selection.removeAllRanges();
//                     selection.removeMarkers();
//                 }, 10);
//             });
//         }

//         return function (scribe) {

//             // keep a reference to scribe so we can access in helper functions ^^
//             scribeRef = scribe;

//             var togglePickerCommand = new scribe.api.SimpleCommand('showcolorpicker');

//             togglePickerCommand.execute = function () {

//                 var selection = new scribe.api.Selection();
//                 selection.placeMarkers();
//                 // Hack to avoid loosing the markers within applyFormatters
//                 scribe._skipFormatters = true;

//                 createPicker();
//             };

//             togglePickerCommand.queryEnabled = function () {
//                 return true;
//             };

//             // togglePickerCommand.queryState = function () {
//             //     // var activeCommand = (someCommandEnabled() ? firstActiveCommand() : null) || commands[0];

//             //     // // set the text for the dropdown element to the active command
//             //     // // command title text is comming from the actual element inside the dropdown
//             //     // activeCommandElement.textContent = activeCommand.title;
//             //     // there is no active/inactive state for the dropdown
//             //     // so always return false
//             //     return true;
//             // };

//             scribe.commands.showcolorpicker = togglePickerCommand;
//         };
//     };

//     Statamic.bard.plugins.push(scribePluginColourPicker);

//     const colorHandler = function (buttons) {
//         buttons.push({
//             text: 'Color',
//             command: 'showcolorpicker',
//             icon: 'paint-brush',
//         });
//     };

//     Statamic.bard.buttons.push(colorHandler);
// }());